import { createSelector } from 'reselect';
import { getStartOf, subtract, toISO } from 'lib/utils/date';
import {
  MAX_QUERY_BOUNDARY_HOURS,
  MAX_QUERY_BOUNDARY_HOURS_APM_ERP,
} from 'lib/constants';
import { getHeavyUpdate } from 'lib/selectors/getUpdate';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';

// this boundary will be recalc'ed on every heavy update - this is to ensure that we quickly switch
// scope when crossing an hour boundary, but will otherwise return the bottom of the hour, N hours ago
// APM ERP flow uses 200h so operator runs can stay in scope even when days old

const getMaxScopeQueryStart = createSelector(
  [getHeavyUpdate, getIsApmERPJobFlow],
  // eslint-disable-next-line no-unused-vars
  (_heavyUpdate, isApmERPJobFlow) => {
    const nowISO = toISO();
    const boundaryHours = isApmERPJobFlow
      ? MAX_QUERY_BOUNDARY_HOURS_APM_ERP
      : MAX_QUERY_BOUNDARY_HOURS;
    // careful if/when changing this boundary - this protection should exist server-side,
    // but adding here as double precaution for any queries/subs driven by scope start
    const maxQueryHoursAgoISO = subtract(nowISO, boundaryHours, 'hours');
    const startOfMaxRangeBoundaryHour = getStartOf(maxQueryHoursAgoISO, 'hour');
    return startOfMaxRangeBoundaryHour;
  }
);

export { getMaxScopeQueryStart };
